import api from '../index'
import {
  IActiveSubject,
  IAddSubject,
  IArchiveSubject,
  IEditSubject,
  IGetSubjects,
  IDuplicateSubject,
  IDelegateSubjectToUser
} from '../models/subjects'

export const getSubjects = (data: IGetSubjects) => {
  return api.get(`/subjects`, { params: data })
}

export const addSubject = (data: IAddSubject) => {
  return api.post('/subjects', data)
}

export const editSubject = (data: IEditSubject) => {
  return api.put('/subjects', data)
}

export const activeSubject = (data: IActiveSubject) => {
  return api.patch('/subjects/recover', data)
}

export const archivedSubject = (data: IArchiveSubject) => {
  return api.delete('/subjects', { data })
}

export const duplicateSubject = (data: IDuplicateSubject) => {
  return api.post(`/subjects/duplicate/${data.id}`)
}

export const delegateSubjectToUser = (data: IDelegateSubjectToUser) => {
  return api.post('/delegate/subjects', data)
}

export const copySubject = (data: {
  id: string | undefined
  areaId: string
}) => {
  return api.post(`/subjects/copy/${data.id}/area/${data.areaId}`)
}
